// Pixel-level grade of a loaded RGBE equirect (half-float DataTexture), kept out of pendant-scene.js.
// Pulls the colour toward its luminance so a strongly tinted interior (e.g. orange lamps) does not turn
// silver into copper; background and environment share the graded texture so they still agree.
import {DataUtils} from 'three'

/**
 * Desaturate a half-float DataTexture in place.
 * @param {import('three').DataTexture} tex texture from RGBELoader (HalfFloatType)
 * @param {number} amount 0 = unchanged, 1 = greyscale
 */
export function desaturate(tex, amount) {
  const data = /** @type {Uint16Array} */ (tex.image.data)
  if (!amount || !(data instanceof Uint16Array)) return
  for (let i = 0; i < data.length; i += 4) {
    const r = DataUtils.fromHalfFloat(data[i])
    const g = DataUtils.fromHalfFloat(data[i + 1])
    const b = DataUtils.fromHalfFloat(data[i + 2])
    const l = 0.2126 * r + 0.7152 * g + 0.0722 * b
    data[i] = DataUtils.toHalfFloat(r + (l - r) * amount)
    data[i + 1] = DataUtils.toHalfFloat(g + (l - g) * amount)
    data[i + 2] = DataUtils.toHalfFloat(b + (l - b) * amount)
  }
  tex.needsUpdate = true
}
